// extracted by mini-css-extract-plugin
export default {"leftArrow":"CustomArrow_leftArrow__++AIB","rightArrow":"CustomArrow_rightArrow__tFEEW","chevron":"CustomArrow_chevron__-NQ9P"};